module.exports = __webpack_public_path__ + "static/cadastro_3-2cbd3228f39f46079937f4c9cddfb9a6.png";